// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dmjE","rootMobile":"styles_rootMobile__1hxGM"};